<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-车辆档案-添加
    -->
    <el-dialog
    title="添加车辆档案"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">

      <!-- <el-form-item label="车辆档案名称" prop="name"><el-input v-model="form.name" placeholder="请输入车辆档案名称" class="max-w460"></el-input></el-form-item> -->

<el-form-item label="设备分类" prop="equipment_category">
  <el-select 
    v-model="form.equipment_category" 
    placeholder="请选择设备分类" 
    class="max-w460"
    :loading="equipmentLoading"
  >
    <el-option 
      v-for="eq in equipmentList" 
      :key="eq.equipment_classification_id" 
      :label="eq.name" 
      :value="eq.equipment_classification_id"
    ></el-option>
  </el-select>
</el-form-item>
<el-form-item label="牌照分类" prop="license_category">
  <el-select 
    v-model="form.license_category" 
    placeholder="请选择牌照分类" 
    class="max-w460"
    :loading="licenseLoading"
  >
    <el-option 
      v-for="license in licenseList" 
      :key="license.license_plate_classification_id" 
      :label="license.name" 
      :value="license.license_plate_classification_id"
    ></el-option>
  </el-select>
</el-form-item>
<el-form-item label="车辆类型" prop="vehicle_category">
  <el-select 
    v-model="form.vehicle_category" 
    placeholder="请选择车辆类型" 
    class="max-w460"
    :loading="vehicleLoading"
  >
    <el-option 
      v-for="vehicle in vehicleList" 
      :key="vehicle.vehicle_classification_id" 
      :label="vehicle.name" 
      :value="vehicle.vehicle_classification_id"
    ></el-option>
  </el-select>
</el-form-item>
<el-form-item label="牌照号码" prop="license_number">
        <div style="display: flex; align-items: center; flex-wrap: wrap;">
          <el-input v-model="form.license_number" placeholder="请输入牌照号码" class="max-w460" style="margin-right: 16px;"></el-input>
          <el-checkbox v-model="form.is_trailer">拖过</el-checkbox>
        </div>
      </el-form-item>
      <el-form-item v-if="form.is_trailer" label="后车牌照" prop="license_number_back">
        <el-input v-model="form.license_number_back" placeholder="请输入后车牌照" class="max-w460"></el-input>
      </el-form-item>
<el-form-item label="所属组织" prop="belong_organization">
  <el-select 
    v-model="form.belong_organization" 
    placeholder="请选择所属组织" 
    class="max-w460"
    :loading="orgLoading"
  >
    <el-option 
      v-for="org in organizationList" 
      :key="org.ma_company_id" 
      :label="org.name" 
      :value="org.ma_company_id"
    ></el-option>
  </el-select>
</el-form-item>
<el-form-item label="行政区域" prop="administrative_region">
  <div style="display: flex;">
    <el-select @change="provinceChange" v-model="form.province_name" filterable placeholder="请选择省份" class="max-w150 mr10">
      <el-option
        v-for="item in province_options"
        :key="item.id"
        :label="item.name"
        :value="item">
      </el-option>
    </el-select>
    <el-select @change="cityChange" v-model="form.city_name" filterable placeholder="请选择城市" :disabled="lock_city" class="max-w150 mr10">
      <el-option
        v-for="item in city_options"
        :key="item.id"
        :label="item.name"
        :value="item">
      </el-option>
    </el-select>
    <el-select @change="regionChange" v-model="form.region_name" filterable placeholder="请选择区域" :disabled="lock_region" class="max-w150">
      <el-option
        v-for="item in region_options"
        :key="item.id"
        :label="item.name"
        :value="item">
      </el-option>
    </el-select>
  </div>
</el-form-item>
<el-form-item label="状态" prop="status">
  <el-radio-group v-model="form.status" class="max-w460">
    <el-radio :label="'1'">正常</el-radio>
    <el-radio :label="'0'">不正常</el-radio>
  </el-radio-group>
</el-form-item>
<el-form-item label="已绑定学员" prop="bound_students">
  <el-input v-model="form.bound_students" placeholder="请选择已绑定学员" class="max-w460" readonly>
    <template slot="append">
      <el-button size="small" @click="openUserSelect">选择</el-button>
    </template>
  </el-input>
</el-form-item>
<el-form-item label="数量" prop="quantity"><el-input v-model="form.quantity" placeholder="请输入数量" class="max-w460" type="number"></el-input></el-form-item>
<!-- 用户选择组件 -->
<GetUser :is_open="showUserSelect" @close="closeDialogFunc"></GetUser>
      <el-form-item label="排序" prop="name"><el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input></el-form-item>
       

    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
     <!--业务附件上传组件-->
     <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
 </div>
</el-dialog>
  
</template>

<script>
import Ma_vehicle_fileApi from '@/api/ma_vehicle_file.js';
import AfuncApi from '@/api/afunc.js';
import Equipment_classificationApi from '@/api/equipment_classification.js';
import License_plate_classificationApi from '@/api/license_plate_classification.js';
import UserApi from '@/api/user.js';
import Upload from '@/components/file/Upload';
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
import GetUser from '@/components/user/GetUser';
export default {
  components: {

     /*图片上传*/
     Upload: Upload,

     draggable,
     Uediter,
     GetUser
  },
  data() {
    return {
         /*是否上传图片*/
         isupload: false,
      isImg: false,  
         /*富文本配置*/
         ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        name: '',
        code: 'custom',
        image:[],
        // categorya:{},
        sort:50,
        intro:"",
        bannar:[],
        belong_organization: '',
        bound_students_ids: '',
        province_name: '',
        province_id: 0,
        city_name: '',
        city_id: 0,
        region_id: 0,
        region_name: '',
        equipment_category: '',
        license_category: '',
        vehicle_category: '',
        license_number: '',
        is_trailer: false,
        license_number_back: ''
      },
      loading: false,
      /*组织列表数据*/
      organizationList: [],
      /*组织列表加载状态*/
      orgLoading: false,
      /*设备分类列表数据*/
      equipmentList: [],
      /*设备分类列表加载状态*/
      equipmentLoading: false,
      /*牌照分类列表数据*/
      licenseList: [],
      /*牌照分类列表加载状态*/
      licenseLoading: false,
      /*车辆分类列表数据*/
      vehicleList: [],
      /*车辆分类列表加载状态*/
      vehicleLoading: false,
      /*验证规则*/
      rules: {
        license_number_back: [
          {
            validator: (rule, value, callback) => {
              if (this.form.is_trailer && !(value && value.trim())) {
                callback(new Error('请输入后车牌照'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ]
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
      code:"album",
      /*是否显示用户选择弹窗*/
      showUserSelect: false,
      /* 城市锁 */
      lock_city:true,
      /* 区域锁 */
      lock_region:true,
      province_options:{},
      city_options:{},
      region_options:{}
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
    this.getOrganizationList();
    this.getEquipmentList();
    this.getLicenseList();
    this.getVehicleList();
    this.getAddressList();
  },
  props: ["open_add"],
  methods: {
    /*获取组织列表*/
    getOrganizationList() {
      let self = this;
      self.orgLoading = true;
      AfuncApi.call({
        model: 'ma_company',
        action: 'getList',
        page: 1,
        list_rows: 1000
      })
        .then(data => {
          self.orgLoading = false;
          if (data.data && data.data.list && data.data.list.data) {
            self.organizationList = data.data.list.data;
          }
        })
        .catch(error => {
          self.orgLoading = false;
        });
    },
    /*获取设备分类列表*/
    getEquipmentList() {
      let self = this;
      self.equipmentLoading = true;
      Equipment_classificationApi.list({}, true)
        .then(data => {
          self.equipmentLoading = false;
          if (data.data && data.data.list && data.data.list.data) {
            self.equipmentList = data.data.list.data;
          }
        })
        .catch(error => {
          self.equipmentLoading = false;
        });
    },
    /*获取牌照分类列表*/
    getLicenseList() {
      let self = this;
      self.licenseLoading = true;
      License_plate_classificationApi.list({}, true)
        .then(data => {
          self.licenseLoading = false;
          if (data.data && data.data.list && data.data.list.data) {
            self.licenseList = data.data.list.data;
          }
        })
        .catch(error => {
          self.licenseLoading = false;
        });
    },
    /*获取车辆类型列表*/
    getVehicleList() {
      let self = this;
      self.vehicleLoading = true;
      AfuncApi.call({
        model: 'vehicle_classification',
        action: 'getList',
        page: 1,
        list_rows: 1000
      })
        .then(data => {
          self.vehicleLoading = false;
          if (data.data && data.data.list && data.data.list.data) {
            self.vehicleList = data.data.list.data;
          }
        })
        .catch(error => {
          self.vehicleLoading = false;
        });
    },

    chooseCategory(){
      this.iscategorya = true;
    },
     /*上传*/
     openUpload(e) {
      this.isupload = true;
    },


     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      if (!form.is_trailer) {
        form.license_number_back = '';
      }
      //form.intro = this.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Ma_vehicle_fileApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
     /*打开上传图片*/
     openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

    /*上传业务附件*/
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.image.concat(e);
        this.$set(this.form, "image", imgs);
      }
      }else{
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.bannar.concat(e);
        this.$set(this.form, "bannar", imgs);
      }
      }
      
      this.isProductUpload = false;
    },

    /*删除业务附件*/
    deleteImg(index,code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      }else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }
      
    },
    /*打开用户选择弹窗*/
    openUserSelect() {
      this.showUserSelect = true;
    },
    /*关闭获取用户弹窗*/
    closeDialogFunc(e) {
      if (e.type != 'error') {
        // 处理选择的用户数据
        this.form.bound_students = e.params.map(user => user.nickName).join(',');
        this.form.bound_students_ids = e.params.map(user => user.user_id).join(',');
      }
      this.showUserSelect = false;
    },
    /* 省份获取 */
    getAddressList(){
      let self = this;
      UserApi.provinceList('',true)
        .then(data => {
          self.province_options = data.data.list;
        })
        .catch(error => {

        });
    },
    /* 市列表 */
    cityList(id){
      let self = this;
      let Params = {}
      Params.province_id = id
      UserApi.city_list(Params,true)
        .then(data => {
          self.city_options = data.data.list
        })
        .catch(error =>{

        });
    },
    /* 区列表 */
    regionList(id){
      let self = this;
      let Params = {}
      Params.region_id = id
      UserApi.region_list(Params,true)
        .then(data => {
          self.region_options = data.data.list
        })
        .catch(error =>{

        });
    },
    /* 选择省 */
    provinceChange(selVal){
      let self = this
      self.form.province_name = selVal.name
      self.form.province_id = selVal.id
      self.form.city_name = ""
      self.form.city_id = ""
      self.form.region_id = ""
      self.form.administrative_region = selVal.name
      self.lock_city = false
      if (!self.lock_region){
        self.lock_region = true
        self.form.region_name = ""
      }
      self.cityList(selVal.id)
    },
    /* 选择市 */
    cityChange(selVal){
      let self = this
      self.form.city_name = selVal.name
      self.form.city_id = selVal.id
      self.form.region_name = ""
      self.form.region_id = ""
      self.form.administrative_region = self.form.province_name + '-' + selVal.name
      if (self.lock_region){
        self.lock_region = false
      }
      self.regionList(selVal.id);
    },
    /* 选择区 */
    regionChange(selVal){
      let self = this
      self.form.region_name = selVal.name
      self.form.region_id = selVal.id
      self.form.administrative_region = self.form.province_name + '-' + self.form.city_name + '-' + selVal.name
      /* 层级太深，需要手动刷新渲染 */
      self.$forceUpdate();
    },

  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}


.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/ma_vehicle_file/index/part/add.vue